import React from "react";
import VisionMissionValue from "./VisionMissionValue";
import RevealBlocksVisionMissionValue from "./RevealBlocksVisionMissionValue";
import CardTrioVisionMissionValue from "./CardTrioVisionMissionValue";
import BoxHighlightVisionMissionValue from "./BoxHighlightVisionMissionValue";
import MinimalIconVisionMissionValue from "./MinimalIconVisionMissionValue";
import { useSelector } from "react-redux";

function WrapperVisionMissionValue({ principles, siteType }) {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <div>
      {sitedata?.theme_vision_mission_values === "box-highlight-grid" ? (
        <BoxHighlightVisionMissionValue
          principles={principles}
          siteType={siteType}
        />
      ) : sitedata?.theme_vision_mission_values === "icon-card-trio" ? (
        <CardTrioVisionMissionValue
          principles={principles}
          siteType={siteType}
        />
      ) : sitedata?.theme_vision_mission_values === "minimal-icon-list" ? (
        <MinimalIconVisionMissionValue
          principles={principles}
          siteType={siteType}
        />
      ) : sitedata?.theme_vision_mission_values === "hover-reveal-blocks" ? (
        <RevealBlocksVisionMissionValue principles={principles} siteType={siteType} />
      ) : (
        <VisionMissionValue principles={principles} siteType={siteType} />
      )}


    </div>
  );
}

export default WrapperVisionMissionValue;
